/* ==================================================================
   Cash Money — فورم الطلب + قفل اللي نفد + إظهار زرار منتجات الألوان
   ================================================================== */
(function () {
  'use strict';

  var KEY = 'cmCodAutoOpen';
  var SOLD_OUT = 'نفدت الكمية';
  var NOTE_CSS =
    'text-align:center;font-weight:700;padding:10px 8px;border-radius:10px;' +
    'background:#F1F1F1;color:#7A7A7A;font-size:14px;line-height:1.4;margin-top:6px;';

  function pageType() {
    var m = document.querySelector('[data-template]');
    var t = (m && m.getAttribute('data-template')) || '';
    if (!t && window.Theme && window.Theme.template) t = window.Theme.template.name || '';
    return String(t).split('.')[0];
  }

  function formOpen() { return !!document.querySelector('#rsi_form_wrapper'); }

  function hideHard(el) {
    if (el && el.style) el.style.setProperty('display', 'none', 'important');
  }

  function note(text) {
    var n = document.createElement('div');
    n.className = 'cm-soldout-note';
    n.textContent = text;
    n.setAttribute('style', NOTE_CSS);
    return n;
  }

  /* ---------- إظهار الزرار في منتجات الفاريانت ----------
     Releasit بيحقن زراره جوّه add-to-cart-component، وثيم Horizon بيخفي
     الـ component ده في المنتجات اللي ليها أكتر من فاريانت. الـ CSS في
     cm-head-assets بتحلها بـ :has()، وده احتياطي للمتصفحات القديمة. */
  function revealButtons() {
    var cs = document.querySelectorAll('.rsi-homepage-container');
    for (var i = 0; i < cs.length; i++) {
      var c = cs[i];
      /* لو إحنا اللي مخفيينه (منتج نفد) مانقربش منه */
      if (getComputedStyle(c).display === 'none') continue;
      if (c.getBoundingClientRect().width > 0) continue;
      var el = c.parentElement, hops = 0;
      while (el && hops++ < 4) {
        if (getComputedStyle(el).display === 'none') {
          el.style.setProperty('display', 'block', 'important');
        }
        el = el.parentElement;
      }
    }
  }

  /* ---------- كروت الأقسام والرئيسية: قفل اللي نفد ---------- */
  function ownerCard(container) {
    var el = container.parentElement, card = null, hops = 0;
    while (el && hops++ < 10) {
      var links = el.querySelectorAll('a[href*="/products/"]').length;
      if (links === 1) card = el;
      else if (links > 1) break;
      el = el.parentElement;
    }
    return card;
  }

  function cardIsSoldOut(card) {
    if (!card) return false;
    return !!card.querySelector(
      '.color-custom-badge-sold-out, .product-badges__badge--sold-out, [class*="badge-sold-out"]'
    );
  }

  function lockSoldOutCards() {
    var cs = document.querySelectorAll('.rsi-homepage-container');
    for (var i = 0; i < cs.length; i++) {
      var c = cs[i];
      if (c.getAttribute('data-cm-checked') === '1') continue;
      var card = ownerCard(c);
      if (!card) continue;
      c.setAttribute('data-cm-checked', '1');
      if (!cardIsSoldOut(card)) continue;
      hideHard(c);
      if (!card.querySelector('.cm-soldout-note')) {
        c.parentNode.insertBefore(note(SOLD_OUT), c.nextSibling);
      }
    }
  }

  /* ---------- صفحات الأقسام: نسجّل الضغطة ---------- */
  function mark(e) {
    if (pageType() === 'product') return;
    var el = e.target;
    if (!el || !el.closest) return;
    if (!el.closest('.rsi-homepage-container') && !el.closest('#rsi_buy_now_button')) return;
    try {
      sessionStorage.setItem(KEY, '1');
      setTimeout(function () {
        try { sessionStorage.removeItem(KEY); } catch (err) {}
      }, 3000);
    } catch (err) {}
  }
  ['pointerdown', 'mousedown', 'touchstart', 'click'].forEach(function (evt) {
    document.addEventListener(evt, mark, { capture: true, passive: true });
  });

  /* ---------- حالة التوفّر في صفحة المنتج ---------- */
  function availability(cb) {
    var m = document.querySelector('meta[name="cm-available"]');
    if (m) { cb(m.getAttribute('content') !== 'false'); return; }
    var path = location.pathname.replace(/\/+$/, '');
    if (!/\/products\//.test(path)) { cb(true); return; }
    try {
      fetch(path + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { cb(!d || d.available !== false); })
        .catch(function () { cb(true); });
    } catch (err) { cb(true); }
  }

  function lockProductPage() {
    ['#floatingBuyNowButton', '#rsi_buy_now_button', '.lp-cta', '.lp-sticky', '.lp-bar']
      .forEach(function (sel) {
        var els = document.querySelectorAll(sel);
        for (var i = 0; i < els.length; i++) hideHard(els[i]);
      });
    var anchor = document.querySelector('.lp-price') || document.querySelector('.lp-title');
    if (anchor && !document.querySelector('.cm-soldout-note')) {
      anchor.parentNode.insertBefore(note(SOLD_OUT + ' — هتكون متاحة قريب'), anchor.nextSibling);
    }
    var w = document.querySelector('#rsi_form_wrapper');
    if (w) { try { w.close ? w.close() : hideHard(w); } catch (err) { hideHard(w); } }
  }

  /* ---------- صفحة المنتج: نفتح الفورم فورًا ---------- */
  function maybeOpen() {
    if (pageType() !== 'product') return;
    var wanted = false;
    try { wanted = sessionStorage.getItem(KEY) === '1'; } catch (err) {}
    if (location.hash === '#order') wanted = true;
    if (/[?&]order=1(&|$)/.test(location.search)) wanted = true;
    try { sessionStorage.removeItem(KEY); } catch (err) {}

    availability(function (ok) {
      if (!ok) { lockProductPage(); return; }
      if (!wanted) return;
      var t0 = Date.now();
      var timer = setInterval(function () {
        if (formOpen()) { clearInterval(timer); return; }
        if (Date.now() - t0 > 20000) { clearInterval(timer); return; }
        var btn = document.querySelector('#rsi_buy_now_button');
        if (btn) { try { btn.click(); } catch (err) {} }
      }, 500);
    });
  }

  /* ---------- إخفاء "Default" جوّه الفورم ---------- */
  function hideDefaultLabel() {
    var nodes = document.querySelectorAll('[class*="rsi-product-item-subtitle"]');
    for (var i = 0; i < nodes.length; i++) {
      var txt = (nodes[i].textContent || '').trim();
      if (txt === 'Default' || txt === 'Default Title') nodes[i].style.display = 'none';
    }
  }

  if (window.MutationObserver) {
    new MutationObserver(function () {
      if (formOpen()) hideDefaultLabel();
      if (pageType() !== 'product') { lockSoldOutCards(); revealButtons(); }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  function boot() {
    maybeOpen();
    if (pageType() !== 'product') {
      lockSoldOutCards(); revealButtons();
      var n = 0;
      var t = setInterval(function () {
        lockSoldOutCards(); revealButtons();
        if (++n > 20) clearInterval(t);
      }, 500);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
